<template>
  <!-- 推荐职位 -->

  <div class="box1">
    <div class="Recommended-box">
      <!-- 搜索 -->

      <div class="search">
        <!-- 筛选选择 -->

        <div class="search-Select">
          <p
            class="search-Select-p"
            v-for="(item, index) in list"
            :key="index"
            :class="item.id == Toggle ? 'Select-p' : ''"
            @click="handelToggle(item.id)"
          >
            {{ item.name }}
          </p>

          <div class="intention-div">
            <p
              v-if="objName !== '' && objAddress != ''"
              class="intention-button"
              :class="5 == Toggle ? 'intention-button-S' : ''"
              @click="handelToggle(5)"
            >
              {{ objName + " - " + objAddress }}
            </p>

            <div class="intention-div-option" v-if="reveal">
              <p
                class="intention-button"
                v-for="(item1, index1) in obj"
                :key="index1"
                :style="item1.positionName == objName ? 'color:#409eff ' : ''"
                @click.stop="handelSelectI(item1)"
              >
                {{
                  item1.addressName
                    ? item1.positionName + " - " + item1.addressName
                    : item1.positionName
                }}
              </p>
            </div>
          </div>

          <div
            v-if="
              obj.length == 0 &&
              this.$store.getters.getUser.id != '' &&
              this.$store.getters.getUser.id != undefined
            "
            class="Add-intention"
            @click="handelAddIntention"
          >
            <div class="Add-icon">
              <div></div>

              <p>添加求职意向</p>
            </div>
          </div>

          <div
            v-if="
              obj.length != 0 &&
              this.$store.getters.getUser.id != '' &&
              this.$store.getters.getUser.id != undefined
            "
            class="intention-Select firm-clickable"
            @click.stop="handelReveal"
          >
            选择
          </div>
        </div>

        <!-- 搜索框 -->

        <div class="search-Search">
          <el-input v-model="input" :placeholder="Tips"></el-input>

          <div class="search_btn">
            <div class="firm-clickable" @click="handelSearch">
              <p><i class="el-icon-search"></i></p>

              搜 索
            </div>
          </div>
        </div>

        <!-- 开启关闭筛选按钮 -->

        <div class="screen-btn">
          <div class="screen-btn-box firm-clickable" @click="screen = !screen">
            <p>筛选</p>
            <div v-if="screen == 1" class="unfold-icon"></div>
            <div v-else class="PackUp-icon"></div>
          </div>
        </div>
      </div>

      <!-- 筛选 -->

      <div class="screen" v-if="screen">
        <comScreen
          :Toggle="Toggle"
          @handelClickTreatment="handelClickTreatment"
          @handelClickType="handelClickType"
          @handelClickExp="handelClickExp"
          @handelClickLearn="handelClickLearn"
          @handelClickScale="handelClickScale"
          @handleUnderstand="handleUnderstand"
          @handelPosition="handelPosition"
        ></comScreen>
      </div>

      <!-- 主体 -->

      <div class="Core">
        <comCore
          :listArr="listArr"
          @Refresh="recommendPositionsByConditions()"
        ></comCore>
      </div>

      <!-- 分页 -->

      <div class="paging">
        <div class="paging-cen">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
// 引入推荐职位页的接口

import {
  recommendPositionsByConditions, // 根据检索条件推 //
  getUserHopePosition, // 查询用户首个求职意向
  ByConditions, // 热门职位查询
} from "../../../assets/api/Recommended";

// 引入接口

import {
  getUserHomeHotDictPositions, // 用户首页热门职位（热门职位 推荐栏）
} from "../../../assets/api/indexl";

// 引入 头部筛选搜索 组件

import comScreen from "./components/comScreen.vue";

// 引入 主体推荐职位 组件

import comCore from "./components/comCore.vue";

// 引入分页组件

import paging from "../../../components/paging.vue";

export default {
  props: {
    cityCodeNum: {},
  },

  components: {
    comScreen,

    comCore,

    paging,
  },

  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页

        pageSize: 15, // 一页显示多少个

        totalDevice: 0, //用户总数
      }, // 分页数据

      list: [
        { name: "推荐职位", id: "1" },

        { name: "热门职位", id: "2" },

        { name: "最新职位", id: "3" },

        { name: "搜索", id: "4" },
      ], // 导航数据

      Toggle: "0", // 切换

      input: "", //搜索

      screen: true, // 筛选

      Tips: "搜索职位", // 传给搜索组件的数据

      listArr: [], // 职位数据列表

      intention: {
        positionCode: [], // 意向职位code

        addressCode: "", // 意向地址code

        hotPositionCode: "", // 热门职位

        min: "", //最低薪资

        max: "", // 最高薪资

        type: "", //求职类型

        Exp: "", // 工作经验

        Learn: "", // 学历要求

        scale: "", //公司规模

        echoVal: [], // 公司行业
      }, // 用户求职意向数据

      cityCodeParameter: "", //上传的地址code有时是 意向中的code有时是上方选择的code

      positionCodeParameter: [], //上传的职位code有时有有时无

      obj: [],

      objAddress: "", //选中的意向地址

      objName: "", // 选中的意向名

      reveal: false, // 求职意向下拉的显示隐藏
    };
  },

  watch: {
    // 监听页面

    Toggle: {
      handler(neWss, old) {
        if (this.Toggle == "1") {
          // 推荐职位：优先使用定位地址，如果没有定位地址才使用求职意向地址
          this.positionCodeParameter = this.intention.positionCode;

          const currentCityCode = localStorage.getItem("cityCode");
          if (currentCityCode && currentCityCode !== "001" && currentCityCode !== "002") {
            this.cityCodeParameter = currentCityCode;
          } else if (this.intention.addressCode != "" && this.intention.addressCode != null) {
            this.cityCodeParameter = this.intention.addressCode;
          } else {
            this.cityCodeParameter = "";
          }

          this.recommendPositionsByConditions();
        } else if (this.Toggle == "2") {
          // 热门职位

          // 先获取 热门职位的第一项id 用于传参数

          getUserHomeHotDictPositions().then((res) => {
            if (res.code == 0) {
              this.intention.hotPositionCode = res.data[0].code;

              this.cityCodeParameter =
                localStorage.getItem("cityCode") == "001" ||
                localStorage.getItem("cityCode") == "002"
                  ? ""
                  : localStorage.getItem("cityCode");

              this.positionCodeParameter = [];

              this.recommendPositionsByConditions();
            }
          });
        } else if (this.Toggle == "3") {
          this.positionCodeParameter = this.intention.positionCode;

          this.cityCodeParameter =
            localStorage.getItem("cityCode") == "001" ||
            localStorage.getItem("cityCode") == "002"
              ? ""
              : localStorage.getItem("cityCode");

          this.recommendPositionsByConditions();
        } else if (this.Toggle == "4") {
          this.positionCodeParameter = [];

          this.cityCodeParameter =
            localStorage.getItem("cityCode") == "001" ||
            localStorage.getItem("cityCode") == "002"
              ? ""
              : localStorage.getItem("cityCode");

          this.recommendPositionsByConditions();
        } else if (this.Toggle == "5") {
          this.positionCodeParameter = this.intention.positionCode;

          this.cityCodeParameter = this.intention.addressCode;

          this.recommendPositionsByConditions();
        }
      },

      immediate: false,
    },

    // 监听页面

    input: {
      handler(newSs, old) {
        if (newSs == "") {
          this.recommendPositionsByConditions();
        }
      },

      immediate: false,
    },

    // 监听页面   top中的地址发生改变

    cityCodeNum: {
      handler(newss, old) {
        if (this.Toggle == "5") {
        } else {
          this.pagingObj = {
            currentPage: 1, //当前页

            pageSize: 15, // 一页显示多少个

            totalDevice: 0, //用户总数
          }; // 分页数据

          this.cityCodeParameter =
            localStorage.getItem("cityCode") == "001" ||
            localStorage.getItem("cityCode") == "002"
              ? ""
              : localStorage.getItem("cityCode");

          this.recommendPositionsByConditions();
        }
      },

      immediate: false,
    },
  },

  created() {
    if (this.$route.query.val != "" && this.$route.query.val != undefined) {
      this.Tips = this.$route.query.val;

      this.input = this.$route.query.val;
    }

    // 先获取用户求职意向接口

    if (
      this.$store.getters.getUser.id != "" &&
      this.$store.getters.getUser.id != undefined
    ) {
      getUserHopePosition().then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.intention.positionCode[0] = res.data[0].positionCode;

            this.intention.addressCode = res.data[0].addressCode;

            this.obj = res.data;

            this.obj.unshift({
              positionName: "添加求职意向",

              addressName: "",
            });

            this.objAddress = this.obj[1].addressName;

            this.objName = this.obj[1].positionName;
          }

          setTimeout(() => {
            if (
              localStorage.getItem("Toggle") == null ||
              localStorage.getItem("Toggle") == "1"
            ) {
              this.Toggle = "1";
            } else {
              this.Toggle = localStorage.getItem("Toggle");
            }
          }, 500);
        }
      });
    } else {
      //用户未登录

      setTimeout(() => {
        if (
          localStorage.getItem("Toggle") == null ||
          localStorage.getItem("Toggle") == "1"
        ) {
          this.Toggle = "1";
        } else {
          this.Toggle = localStorage.getItem("Toggle");
        }
      }, 500);
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },

  // 离开页面删除推荐页面的本地数据存储

  destroyed() {
    localStorage.removeItem("Toggle");
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    // 重置分页

    pagingObjReset() {
      this.pagingObj = {
        currentPage: 1, //当前页

        pageSize: 15, // 一页显示多少个

        totalDevice: 0, //用户总数
      }; // 分页数据
    },

    // 点击上方推荐职位 热门职位 最新职位...

    handelToggle(item) {
      this.pagingObjReset();

      localStorage.setItem("Toggle", item);

      this.Toggle = item;

      if (item == "4") {
        // this.intention.min = ""; //最低薪资
        // this.intention.max = ""; // 最高薪资
        // this.intention.type = ""; //求职类型
        // this.intention.Exp = ""; // 工作经验
        // this.intention.Learn = ""; // 学历要求
        // this.intention.scale = ""; //公司规模
        // this.intention.echoVal = []; // 公司行业
      } else if (item == "2") {
        this.input = "";
      } else if (item == "5") {
        this.input = "";

        this.positionCodeParameter = this.intention.positionCode;

        this.cityCodeParameter = this.intention.addressCode;

        this.recommendPositionsByConditions();
      } else {
        this.input = "";
      }
    },

    // -------------------- 推荐职位 -----------------

    async recommendPositionsByConditions() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,

          // 意向地址/定位地址

          addressCode: this.cityCodeParameter,

          // // 意向职位

          dictPositionCodeList: this.positionCodeParameter,

          // 热门职位

          hotPositionCode:
            this.Toggle == "2" ? this.intention.hotPositionCode : "",

          // 求职类型

          jobType: this.intention.type,

          // 最低薪资

          salaryMin: this.intention.min,

          // 最高薪资

          salaryMax: this.intention.max,

          //工作经验

          workExperienceId: this.intention.Exp,

          // 学历要求

          xlId: this.intention.Learn,

          // 公司规模

          companySizeId: this.intention.scale,

          // 公司行业

          industryTypeCode: this.intention.echoVal,

          // 搜索

          positionName: this.input,
        },
      };

      // 请求接口

      const res = await recommendPositionsByConditions(
        data,

        this.pagingObj.currentPage, // 当前页

        this.pagingObj.pageSize // 一页几条
      );

      // 接口调用成功

      if (res.code == 0) {
        // 拿到总数量

        this.pagingObj.totalDevice = res.data.total;

        // 拿到当前页数据

        this.listArr = res.data.list;
      }
    },

    //-------------------------- 查询用户首个求职意向 ------------

    async getUserHopePosition() {
      const res = await getUserHopePosition();

      if (res.data.length > 0) {
        this.intention.positionCode[0] = res.data[0].positionCode;

        this.intention.addressCode = res.data[0].addressCode;

        this.obj = res.data;

        this.obj.unshift({
          positionName: "添加求职意向",

          addressName: "",
        });

        this.objAddress = this.obj[1].addressName;

        this.objName = this.obj[1].positionName;
      }
    },

    // --------------------- handelSearch 搜索

    handelSearch() {
      this.pagingObjReset();

      this.Toggle = "4";

      this.recommendPositionsByConditions();
    },

    // ------------------------热门职位筛选 handelPosition -------------------------

    handelPosition(val) {
      this.pagingObjReset();

      this.intention.hotPositionCode = val;

      this.recommendPositionsByConditions();
    },

    // ----------------------------handelClickTreatment  薪资待遇 -----------------------

    handelClickTreatment(min, max) {
      this.pagingObjReset();

      this.intention.min = min;

      this.intention.max = max;

      this.recommendPositionsByConditions();
    },

    // -------------------------handelClickType求职类型- ----------------------

    handelClickType(val) {
      this.pagingObjReset();

      this.intention.type = val;

      this.recommendPositionsByConditions();
    },

    // ----------------------handelClickExp工作经验 ------------

    handelClickExp(val) {
      this.pagingObjReset();

      this.intention.Exp = val;

      this.recommendPositionsByConditions();
    },

    // -----------------handelClickLearn 学历要求 -----

    handelClickLearn(val) {
      this.pagingObjReset();

      this.intention.Learn = val;

      this.recommendPositionsByConditions();
    },

    // ----------------- handelClickScale公司规模

    handelClickScale(val) {
      this.pagingObjReset();

      this.intention.scale = val;

      this.recommendPositionsByConditions();
    },

    // ---------------- handleUnderstand 公司行业切换

    handleUnderstand(val) {
      this.pagingObjReset();

      this.intention.echoVal = val;

      this.recommendPositionsByConditions();
    },

    // 点击选择求职意向

    handelSelectI(item) {
      this.reveal = !this.reveal;

      if (item.positionName == "添加求职意向") {
        this.$router.push({ path: "/Centre/cenJane", val: "添加求职意向" });
      } else {
        this.intention.positionCode[0] = item.positionCode;

        this.intention.addressCode = item.addressCode;

        this.objAddress = item.addressName;

        this.objName = item.positionName;

        this.handelToggle(5);
      }
    },

    // 点击选择显示/隐藏求职下拉

    handelReveal() {
      this.reveal = !this.reveal;
    },

    // 点击外部关闭下拉菜单
    handleClickOutside(event) {
      const intentionDiv = this.$el.querySelector('.intention-div');
      if (intentionDiv && !intentionDiv.contains(event.target)) {
        this.reveal = false;
      }
    },

    // 点击添加求职意向

    handelAddIntention() {
      this.$router.push({ path: "/Centre/cenJane", val: "添加求职意向" });
    },

    // 分页

    handleCurrentChange(num) {
      // num 要跳转的页面

      this.pagingObj.currentPage = num;

      // 调用数据接口

      this.recommendPositionsByConditions();
    },
  },
};
</script>



<style scoped lang="less">
.box1 {
  width: 100%;
}

.Recommended-box {
  width: 100%;

  display: flex;

  flex-direction: column;
}

//搜索区

.search {
  min-width: 1136px;

  height: 30px;

  margin: auto;

  margin-top: 20px;

  margin-bottom: 20px;

  display: flex;

  // 搜索区 选择

  .search-Select {
    flex: 1;

    height: 28px;

    line-height: 28px;

    display: flex;

    margin: auto 0;

    .search-Select-p {
      padding-left: 5px;

      padding-right: 5px;

      width: 90px;

      height: 28px;

      background: #eeeeee;

      border-radius: 5px;

      font-family: PingFangSC-Medium;

      font-size: 14px;

      color: #999999;

      text-align: center;

      font-weight: 400;

      margin-right: 10px;

      cursor: pointer;

      text-overflow: ellipsis;

      white-space: nowrap;

      overflow: hidden;
    }

    .Select-p {
      background: rgba(97, 144, 232, 0.2);

      border-radius: 5px;

      color: #409eff ;
    }

    .intention-div {
      position: relative;

      .intention-div-option {
        width: 190px;
        position: absolute;

        left: 0;

        top: 100%;

        margin-top: 8px;

        padding: 8px 0;
        min-height: 30px;

        background: #ffffff;

        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

        border-radius: 8px;

        border: 1px solid #e4e7ed;

        z-index: 1000;
        box-sizing: border-box;

        .intention-button {
          width: 100%;
          height: 38px;
          background: #ffffff;

          padding: 8px 12px;

          transition: all 0.2s;
          box-sizing: border-box;
        }

        .intention-button:hover {
          background: #f5f7fa;

          color: #409eff ;
        }
      }
    }

    .intention-button {
      padding-left: 5px;

      padding-right: 5px;

      width: 180px;

      height: 28px;

      background: #eeeeee;

      border-radius: 5px;

      font-family: PingFangSC-Medium;

      font-size: 14px;

      color: #999999;

      text-align: center;

      font-weight: 400;

      margin-right: 10px;

      cursor: pointer;

      text-overflow: ellipsis;

      white-space: nowrap;

      overflow: hidden;

      flex-shrink: 0;
    }

    .intention-button-S {
      background: rgba(97, 144, 232, 0.2);

      border-radius: 5px;

      color: #409eff ;
    }

    .intention-Select {
      font-size: 14px;

      height: 28px;

      line-height: 28px;

      width: 60px;

      color: #ffffff;

      margin-left: 0;

      background: #409eff ;

      text-align: center;

      border-radius: 5px;

      cursor: pointer;
    }

    .intention-Select:hover {
      background: #4a7ad1;
    }

    // 添加求职意向

    .Add-intention {
      min-width: 120px;

      height: 28px;

      background: #409eff ;

      display: flex;

      cursor: pointer;

      border-radius: 5px;

      transition: all 0.3s;

      padding: 0 10px;
    }

    .Add-intention:hover {
      background: #4a7ad1;
    }

    .Add-intention .Add-icon {
      min-width: 18px;

      margin: auto;

      font-size: 12px;

      color: #ffffff;

      font-weight: 400;

      display: flex;

      p {
        cursor: pointer;
      }

      div {
        width: 18px;

        height: 18px;

        background-image: url("../../../assets/imgs/tianjia@3x.svg");

        background-size: 100% 100%;

        margin: auto 0;

        margin-right: 5px;
      }
    }
  }

  // 搜索区 搜索

  .search-Search {
    width: 310px;

    height: 28px;

    line-height: 54px;

    margin-right: 15px;

    display: flex;

    position: relative;

    // input框的样式

    /deep/.el-input__inner {
      width: 235px;

      font-size: 14px;

      line-height: 28px;

      height: 30px !important;

      box-sizing: border-box;

      border: 2px solid #409eff ;

      background: #ffffff;

      position: absolute;

      border-radius: 10px;

      z-index: 1;
    }

    // 搜索按钮样式

    .search_btn {
      font-size: 14px;

      color: #ffffff;

      font-weight: 400;

      line-height: 50px;

      background-color: #409eff ;

      width: 80px;

      border: 2px solid #409eff ;

      height: 26px;

      border-radius: 0px 10px 10px 0px;

      cursor: pointer;

      position: absolute;

      right: 0;

      display: flex;

      white-space: nowrap;

      div {
        width: 60px;

        height: 20px;

        line-height: 20px;

        margin: auto;

        display: flex;

        p {
          width: 20px;

          height: 20px;

          margin-right: 3px;

          cursor: pointer;
        }
      }
    }
  }

  // 筛选按钮

  .screen-btn {
    width: 85px;

    height: 28px;

    background: #409eff ;

    border-radius: 5px;

    display: flex;

    cursor: pointer;

    margin: auto 0;

    .screen-btn-box {
      min-width: 10px;

      margin: auto;

      display: flex;

      font-family: PingFangSC-Medium;

      font-size: 14px;

      color: #ffffff;

      font-weight: 400;

      p {
        cursor: pointer;
      }

      .unfold-icon {
        width: 13px;

        height: 8px;

        background-image: url("../../../assets/imgs/arrow-drop-down-fill@3x.svg");

        background-size: 100% 100%;

        margin: auto 0;

        margin-left: 5px;

        display: block;

        filter: brightness(0) invert(1);
      }

      .PackUp-icon {
        width: 13px;

        height: 8px;

        background-image: url("../../../assets/imgs/arrow-drop-up-fill@3x.svg");

        background-size: 100% 100%;

        margin: auto 0;

        margin-left: 5px;

        display: block;

        filter: brightness(0) invert(1);
      }
    }
  }
}

// 筛选区

.screen {
  min-width: 1136px;

  background: #ffffff;

  margin: auto;

  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);

  border-radius: 10px;

  margin-bottom: 30px;
}

.Core {
  width: 1136px;

  min-height: 800px;

  margin: 0 auto;

  margin-top: -20px;
}

.paging {
  min-width: 1200px;

  margin: auto;

  display: flex;

  margin-top: 20px;

  .paging-cen {
    margin: auto;
  }
}
</style>

